<template>
    <div class="wrapper">
        <NavBar />
        <Menu />
        <!-- Spinner Start -->
        <div id="spinner" v-if="halamanloading"
            class="show bg-white position-fixed translate-middle w-100 vh-100 top-50 start-50 d-flex align-items-center justify-content-center">
            <div class="spinner-border text-danger" style="width: 3rem; height: 3rem;" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
        <!-- Spinner End -->
        <div class="content-wrapper py-3">
            <div class="content-header">
                <div class="container-fluid">
                    <div class="row mb-2">
                        <div class="col-sm-6 wow fadeInDown">
                            <h5>Aduan Masyarakat</h5>
                        </div>
                        <div class="col-sm-6 wow fadeInDown">
                            <ol class="breadcrumb float-sm-right">
                                <li class="breadcrumb-item"><a href="/Dashboard">Home </a></li>
                                <li class="breadcrumb-item active">Pengaturan Aduan Masyarakat</li>
                            </ol>
                        </div>
                    </div><!-- /.row -->
                </div><!-- /.container-fluid -->
            </div>
            <!-- /.content-header -->
            <div class="content">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-sm-12 float-left pb-2 px-3 wow fadeInDown">
                            Jumlah Data {{ G_numFormat(jumlahdata) }}
                            <span style="float: right;display: none;">
                                <span>Halaman ke: </span>
                                <select v-model="halaman" @change="onChangeHalaman($event)">
                                    <option v-for="index in jumlahhalaman" :key="index">
                                        {{ index }}</option>
                                </select>
                                <span> dari </span> {{ jumlahhalaman }}
                            </span>
                        </div>
                        <div class="col-sm-12 wow fadeInDown">
                            <div class="card cardputih">
                                <div class="card-header border-transparent">
                                    <div class="card-tools">
                                        <button type="button" class="btn btn-tool" data-card-widget="collapse">
                                            <i class="fas fa-minus"></i>
                                        </button>
                                    </div>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-sm-12 wow fadeInDown">
                                        <div class="card card-warning collapsed-card">
                                            <div class="card-header border-transparent" data-card-widget="collapse"
                                                style="cursor: pointer;">
                                                <label>Filter Data</label>
                                                <div class="card-tools">
                                                    <button type="button" class="btn btn-tool"
                                                        data-card-widget="collapse">
                                                        <i class="fas fa-plus"></i>
                                                    </button>
                                                </div>
                                            </div>
                                            <div class="card-body px-3">
                                                <div class="row">
                                                    <div class="col-sm-4 float-left pb-2">
                                                        <label>Tanggal</label>
                                                        <input type="date" v-model="tanggal"
                                                            class="form-control form-control-sm"
                                                            placeholder="Masukkan Kata Kunci Pencarian"
                                                            @change="ambildata()">
                                                    </div>
                                                    <div class="col-sm-4 float-left pb-2">
                                                        <label>Register</label>
                                                        <input type="text" v-model="register"
                                                            class="form-control form-control-sm"
                                                            placeholder="Masukkan Kata Kunci Pencarian"
                                                            @keyup="ambildata()">
                                                    </div>
                                                    <div class="col-sm-4 float-left pb-2">
                                                        <label>Judul</label>
                                                        <input type="text" v-model="carikata"
                                                            class="form-control form-control-sm"
                                                            placeholder="Masukkan Kata Kunci Pencarian"
                                                            @keyup="ambildata()">
                                                    </div>
                                                    <div class="col-sm-4 float-left pb-2">
                                                        <label>Lokasi</label>
                                                        <v-select :options="lokasi" :reduce="(label) => label.code"
                                                            label="label" v-model="defaultSelectedlokasi"
                                                            @update:modelValue="onlokasiChange"
                                                            style="background-color: #ffffff;color: black;"></v-select>
                                                    </div>
                                                    <div class="col-sm-4 float-left pb-2">
                                                        <label>Kategori</label>
                                                        <v-select :options="masteraduan" :reduce="(label) => label.code"
                                                            label="label" v-model="defaultSelectedmasteraduan"
                                                            @update:modelValue="onmasteraduanChange"
                                                            style="background-color: #ffffff;"></v-select>
                                                    </div>
                                                    <div class="col-sm-4 float-left pb-2">
                                                        <label>Saluran Aduan</label>
                                                        <v-select :options="saluranaduan"
                                                            :reduce="(label) => label.code" label="label"
                                                            v-model="defaultSelectedsaluranaduan"
                                                            @update:modelValue="onsaluranaduanChange"
                                                            style="background-color: #ffffff;"></v-select>
                                                    </div>
                                                    <div class="col-sm-4 float-left pb-2">
                                                        <label>PIC</label>
                                                        <v-select :options="id_user" :reduce="(label) => label.code"
                                                            label="label" v-model="defaultSelectedid_user"
                                                            @update:modelValue="onid_userChange"
                                                            style="background-color: #ffffff;"></v-select>
                                                    </div>
                                                    <div class="col-sm-4 float-left pb-2">
                                                        <label>Status Aduan</label>
                                                        <v-select :options="status_aduan"
                                                            :reduce="(label) => label.code" label="label"
                                                            v-model="defaultSelectedstatus_aduan"
                                                            @update:modelValue="onstatus_aduanChange"
                                                            style="background-color: #ffffff;"></v-select>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-12">
                                        <div class="row">
                                            <div class="col-sm-6 text-center p-2" v-if="leveluser < 9">
                                                <button type="button" class="btn btn-danger3 btn-sm text-white lebar2"
                                                    @click="prosesdata('Tambah')" data-toggle="tooltip"
                                                    data-placement="left" title="Tambah data..">
                                                    <i class="fas fa-plus"></i> Tambah
                                                </button>
                                            </div>
                                            <div class="col-sm-6 text-center">
                                                <a class="hitam">
                                                    <button type="button"
                                                        class="btn btn-success btn-sm text-white lebar2"
                                                        data-toggle="tooltip" data-placement="left"
                                                        title="Unduh excel.." @click="G_tableCSVTabel1('_PIP_')">
                                                        <i class="fas fa-download"></i>
                                                        <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                                            Unduh Data .xlsx
                                                        </span>
                                                        <span v-else>
                                                            Download Data .xlsx
                                                        </span>
                                                    </button>
                                                </a>
                                            </div>
                                        </div>
                                        <div class="col-sm-12">&nbsp;</div>
                                    </div>
                                    <div class="table-responsive table-wrapper px-3" style="font-size: smaller;">
                                        <table class="table m-0" id="tabeldata">
                                            <thead>
                                                <tr>
                                                    <th style="width: 50px;">No</th>
                                                    <th style="width: 150px;" v-if="leveluser < 9">Opsi</th>
                                                    <th style="width: 50px;">Register</th>
                                                    <th style="width: 50px;">Unit Pelaksana</th>
                                                    <th style="width: 100px;">Paket Kegiatan</th>
                                                    <th style="width: 50px;">Tanggal Diterima</th>
                                                    <th style="width: 50px;">Lokasi</th>
                                                    <th style="width: 100px;">Media</th>
                                                    <th style="width: 100px;">Judul</th>
                                                    <th style="width: 100px;">Informasi / Pengaduan</th>
                                                    <th style="width: 100px;">Bentuk Tidak Lanjut Yang Dilakukan</th>
                                                    <th style="width: 100px;">Kategori</th>
                                                    <th style="width: 100px;">Pelapor</th>
                                                    <th style="width: 100px;">PIC / Pihak Yang Menanggapi</th>
                                                    <th style="width: 100px;">Status</th>
                                                    <th style="width: 100px;">Tanggal Selesai</th>
                                                    <th style="width: 100px;">Lama Penyelesaian (Hari)</th>
                                                    <th style="width: 100px;">Sifat Aduan</th>
                                                    <th style="width: 100px;">Keterangan</th>
                                                </tr>
                                            </thead>
                                            <template v-for="(datalist, urutlist) in filteredKataData" :key="urutlist">
                                                <tbody>
                                                    <tr>
                                                        <td class="text-center">{{ urutlist + 1 }}</td>
                                                        <td class="text-center" v-if="leveluser < 9">
                                                            <button type="button"
                                                                style="font-size: smaller;width: 150px !important;"
                                                                class="btn btn-primary3 btn-sm lebar2 text-white"
                                                                @click="prosesdata(datalist.id)" data-toggle="tooltip"
                                                                data-placement="left" title="Edit data.."><i
                                                                    class="fas fa-edit"></i> Edit / Disposisi
                                                                Data</button>
                                                            <button type="button"
                                                                style="font-size: smaller;width: 150px !important;"
                                                                class="btn btn-success btn-sm lebar2 text-white"
                                                                @click="tindaklanjutdata(datalist.id)"
                                                                data-toggle="tooltip" data-placement="left"
                                                                title="Edit data.."><i class="fas fa-arrow-up"></i>
                                                                Proses Data</button>
                                                            <button type="button"
                                                                style="font-size: smaller;width: 150px !important;"
                                                                class="btn btn-info3 btn-sm lebar2 text-white"
                                                                @click="hapus(datalist.id)" data-toggle="tooltip"
                                                                data-placement="left" title="Hapus data.."><i
                                                                    class="fas fa-trash-alt"></i> Hapus Data</button>
                                                            <a :href="filenya_images + datalist.filenya_images"
                                                                target="_blank"
                                                                v-if="datalist.filenya_images != '' && datalist.filenya_images != null">
                                                                <button type="button"
                                                                    style="font-size: smaller;width: 150px !important;"
                                                                    v-if="datalist.filenya_images != '' && datalist.filenya_images != null"
                                                                    class="btn btn-info bg-red btn-sm lebar2 text-white"
                                                                    data-toggle="tooltip" data-placement="left"
                                                                    title="Lihat Lampiran Foto.."><i
                                                                        class="far fa-file-image"></i> Lihat File
                                                                    Foto
                                                                </button>
                                                            </a>
                                                            <a :href="filenya_pdf + datalist.filenya_pdf"
                                                                target="_blank"
                                                                v-if="datalist.filenya_pdf != '' && datalist.filenya_pdf != null">
                                                                <button type="button"
                                                                    style="font-size: smaller;width: 150px !important;"
                                                                    v-if="datalist.filenya_pdf != '' && datalist.filenya_pdf != null"
                                                                    class="btn btn-info btn-sm lebar2 text-white"
                                                                    data-toggle="tooltip" data-placement="left"
                                                                    title="Lihat Lampiran PDF.."><i
                                                                        class="far fa-file-pdf"></i> Lihat File
                                                                    PDF</button>
                                                            </a>
                                                        </td>
                                                        <td>
                                                            {{ datalist.register }}
                                                        </td>
                                                        <td>
                                                            {{ datalist.full_name }}
                                                        </td>
                                                        <td>
                                                            {{ datalist.Nama_Kegiatan }}
                                                        </td>
                                                        <td>
                                                            {{ G_formatDateNonWIB(datalist.createddate) }}
                                                        </td>
                                                        <td>
                                                            {{ datalist.namalokasi }}
                                                        </td>
                                                        <td>
                                                            {{ datalist.namaasaladuan }}
                                                        </td>
                                                        <td>
                                                            {{ datalist.judul }}
                                                        </td>
                                                        <td>
                                                            <span v-html="datalist.aduan"></span>
                                                        </td>
                                                        <td>
                                                            <span v-html="datalist.tindaklanjut"></span>
                                                        </td>
                                                        <td>
                                                            {{ datalist.kategoriMasalahNm }}
                                                        </td>
                                                        <td>
                                                            {{ datalist.nama }}
                                                        </td>
                                                        <td>
                                                            {{ datalist.pihak_menanggapi }}
                                                        </td>
                                                        <td>
                                                            {{ datalist.namastatusaduan }}
                                                        </td>
                                                        <td>
                                                            {{ G_formatDateNonWIB(datalist.finishdate) }}
                                                        </td>
                                                        <td class="text-center">
                                                            {{ datalist.lamahari }}
                                                        </td>
                                                        <td class="text-center">
                                                            {{ datalist.namasifataduan }}
                                                        </td>
                                                        <td>
                                                            <span v-html="datalist.keterangan"></span>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </template>
                                            <tbody v-if="(datapesan == 'data kosong')">
                                                <tr>
                                                    <td colspan="4">Data masih kosong</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div class="card-footer p-3">

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Footer />
    </div>
</template>

<script>
import $ from 'jquery';
import axios from 'axios';
import vSelect from 'vue-select';
import swal from 'sweetalert2';
import CryptoJS from 'crypto-js';
import xlsx from 'xlsx/dist/xlsx.full.min';
import Footer from "../../componen/Footer.vue";
import NavBar from "../../componen/NavBar.vue";
import Menu from "../../componen/Menu.vue";

import VueApexCharts from "vue3-apexcharts";
window.Apex.chart = { fontFamily: "Poppins-SemiBold, Arial, sans-serif" };
export default {
    components: {
        Footer, NavBar, Menu, vSelect, swal
    },
    data() {
        return {
            halamanloading: true,
            iduser: JSON.parse(localStorage.getItem("usistem")),
            leveluser: JSON.parse(localStorage.getItem("lsistem")),
            namauser: JSON.parse(localStorage.getItem("nmusistem")),
            levelinstansi: JSON.parse(localStorage.getItem("inssistem")),
            roleuser: JSON.parse(localStorage.getItem("rlsistem")),
            datapesan: '',
            datamaster: [],
            carikata: '',
            tanggal: '',
            register: '',
            datapesan: '',
            jumlahdata: 0,
            jumlahhalaman: 0,
            mulai: 0,
            halaman: 1,
            datamasteraduan: [],
            masteraduan: [],
            defaultSelectedmasteraduan: {
                code: 0,
                label: 'Semua Data',
                tag: 0,
            },
            selectedmasteraduan: '',
            id_user: [],
            dataid_user: [],
            defaultSelectedid_user: {
                code: 0,
                label: 'Semua Data',
                tag: '',
            },
            selectedid_user: 0,
            lokasi: [],
            datalokasi: [],
            defaultSelectedlokasi: {
                code: 0,
                label: 'Semua Lokasi',
                tag: '',
            },
            selectedlokasi: '',
            datasaluranaduan: [],
            saluranaduan: [],
            defaultSelectedsaluranaduan: {
                code: 0,
                label: 'Semua Data',
                tag: '',
            },
            selectedsaluranaduan: '',

            datastatus_aduan: [],
            status_aduan: [],
            defaultSelectedstatus_aduan: {
                code: 0,
                label: 'Semua Data',
                tag: '',
            },
            selectedstatus_aduan: '',
            project_id: process.env.VUE_APP_PROJECT_ID,
            filenya_images: process.env.VUE_APP_URL_API + 'maps_parastapainnovationgambar-Gambar?f=',
            filenya_pdf: process.env.VUE_APP_URL_API + 'maps_parastapainnovationpdf-PDF?f=',
        }
    },
    computed: {
        filteredKataData() {
            const filteredWorkers = this.carikata === ""
                ? this.datamaster
                : this.datamaster.filter(wo => Object.values(wo).join("").toLowerCase().indexOf(this.carikata.toLowerCase()) !== -1);
            return filteredWorkers;
        },
        JumlahfilteredKataData() {
            var jumlah = 0;
            try {
                if (this.filteredKataData === undefined) {
                    jumlah = 0;
                } else {
                    jumlah = this.filteredKataData.length;
                }
            }
            catch {
                jumlah = 0;
            }
            return jumlah;
        },
    },
    methods: {
        async G_tableCSVTabel1(namefile) {
            this.halamanloading = true;
            const XLSX = xlsx;
            var wb = XLSX.utils.table_to_book(document.getElementById('tabeldata'), { sheet: "ReportPIP" });
            XLSX.writeFile(wb, this.G_formatDate(Date(), 'd-M-Y') + namefile + ".xlsx");
            this.halamanloading = false;
        },
        getOtentifikasi() {
            var time = Date.parse(localStorage.getItem("tsistem"));
            var timeakhir = time + (3 * 60 * 60 * 1000);
            var timesekarang = Date.parse(new Date());
            if (timesekarang > timeakhir) {
                this.ClearlocalStorage();
            }
        },
        async ambilmaster() {
            this.halamanloading = true;

            const mainAPI5 = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            var random = Math.random();
            await mainAPI5.get("parastapainnovation_userproject-GetPIU?random=" + random + "&project_id=" + this.project_id + "&id_user=" + this.levelinstansi + "&role=" + this.roleuser).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.dataid_user = [];
                        this.id_user = [];
                        this.dataid_user = Response.data.content.data;
                        this.dataid_user.forEach((item) => {
                            if (this.roleuser == 'user') {
                                this.selectedid_user = this.levelinstansi;
                                if (this.selectedid_user == item.user_id) {
                                    this.defaultSelectedid_user = {
                                        code: this.dataid_user.indexOf(item) + 1,
                                        label: item.nama_satker,
                                        tag: item.user_id
                                    };
                                }
                            }
                            this.id_user.push({
                                label: item.nama_satker,
                                code: this.dataid_user.indexOf(item) + 1,
                                tag: item.user_id,
                            });
                        });
                        this.id_user.unshift({
                            label: 'Semua Data',
                            code: 0,
                            tag: '',
                        });
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                this.ClearlocalStorage();
                this.halamanloading = false;
            });
            const mainAPI9 = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer PMC2024Q06S0rZXcJyEH3wk8jVrINbHwn7tBq2",
                },
            });
            var random = Math.random();
            await mainAPI9.get("parastapainnovationMasyarakat-Master?random=" + random).then(
                Response => {
                    this.datapesan = Response.data.message;
                    if (this.datapesan == 'data diketemukan') {
                        this.datamasteraduan = [];
                        this.masteraduan = [];
                        this.datamasteraduan = Response.data.content.data;
                        this.datamasteraduan.forEach((item) => {
                            this.masteraduan.push({
                                label: item.kategoriMasalahNm,
                                code: this.datamasteraduan.indexOf(item) + 1,
                                tag: item.id,
                            });
                        });
                        this.masteraduan.unshift({
                            label: 'Semua Data',
                            code: 0,
                            tag: '',
                        });
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });

            await mainAPI9.get("parastapainnovationMasyarakat-Media?random=" + random).then(
                Response => {
                    this.datapesan = Response.data.message;
                    if (this.datapesan == 'data diketemukan') {
                        this.datasaluranaduan = [];
                        this.saluranaduan = [];
                        this.datasaluranaduan = Response.data.content.data;
                        this.datasaluranaduan.forEach((item) => {
                            this.saluranaduan.push({
                                label: item.nama,
                                code: this.datasaluranaduan.indexOf(item) + 1,
                                tag: item.id,
                            });
                        });
                        this.saluranaduan.unshift({
                            label: 'Semua Data',
                            code: 0,
                            tag: '',
                        });
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });

            await mainAPI9.get("parastapainnovationreffmonitoring-Lokasi?random=" + random + "&project_id=" + this.project_id).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.datalokasi = [];
                        this.lokasi = [];
                        this.datalokasi = Response.data.content.data;
                        this.datalokasi.forEach((item) => {
                            this.lokasi.push({
                                label: item.nama,
                                code: this.datalokasi.indexOf(item) + 1,
                                tag: item.id,
                            });
                        });
                        this.lokasi.unshift({
                            label: 'Semua Lokasi',
                            code: 0,
                            tag: '',
                        });
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });

            await mainAPI9.get("parastapainnovationMasyarakat-Status?random=" + random).then(
                Response => {
                    this.datapesan = Response.data.message;
                    if (this.datapesan == 'data diketemukan') {
                        this.datastatus_aduan = [];
                        this.status_aduan = [];
                        this.datastatus_aduan = Response.data.content.data;
                        this.datastatus_aduan.forEach((item) => {
                            this.status_aduan.push({
                                label: item.nama,
                                code: this.datastatus_aduan.indexOf(item) + 1,
                                tag: item.id,
                            });
                        });
                        this.status_aduan.unshift({
                            label: 'Semua Data',
                            code: 0,
                            tag: '',
                        });
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });
        },
        onstatus_aduanChange(a) {
            try {
                this.selectedstatus_aduan = this.status_aduan[a].tag;
            }
            catch (err) {
                return;
            }
            this.ambildata();
        },
        onmasteraduanChange(a) {
            try {
                this.selectedmasteraduan = this.masteraduan[a].tag;
            }
            catch (err) {
                return;
            }
            this.ambildata();
        },
        onsaluranaduanChange(a) {
            try {
                this.selectedsaluranaduan = this.saluranaduan[a].tag;
            }
            catch (err) {
                return;
            }
            this.ambildata();
        },
        onid_userChange(a) {
            try {
                this.selectedid_user = this.id_user[a].tag;
            }
            catch (err) {
                return;
            }
            this.ambildata();
        },
        onlokasiChange(a) {
            try {
                this.selectedlokasi = this.lokasi[a].tag;
            }
            catch (err) {
                return;
            }
            this.ambildata();
            //alert(this.selectedlokasi);
        },
        onChangeHalaman(event) {
            this.pindahhalaman(event.target.value);
        },
        async pindahhalaman(halamannya) {
            this.halamanloading = true;
            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            var random = Math.random();
            await mainAPI.get("parastapainnovationaduan-GetAduan?random=" + random + "&project_id=" + this.project_id + "&id_user=" + this.levelinstansi + "&role=" + this.roleuser + "&nama=" + this.carikata + "&tanggal=" + this.tanggal + "&register=" + this.register + "&lokasi=" + this.selectedlokasi + "&jenis=" + this.selectedmasteraduan + "&id_user=" + this.selectedid_user + "&saluran=" + this.selectedsaluranaduan + "&status=" + this.selectedstatus_aduan + "&idpiu=" + this.selectedid_user + "&halaman=" + halamannya).then(
                Response => {
                    this.datapesan = Response.data.message;
                    this.colspan = 0;
                    this.datatahun = [];
                    this.colspan = Response.data.jumlahtahun;
                    this.datatahun = Response.data.tahun;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.datamaster = [];
                        this.jumlahdata = Response.data.content.jumlahdata;
                        this.jumlahhalaman = Response.data.content.jumlahhalaman;
                        this.mulai = Response.data.content.mulai;
                        if (this.mulai == 0) {
                            this.halaman = 1;
                        }
                        else {
                            this.halaman = (this.mulai / 20) + 1;
                        }
                        this.datamaster = Response.data.content.data;
                    }
                    else {
                        this.datamaster = [];
                        this.jumlahdata = 0;
                        this.jumlahhalaman = 0;
                        this.mulai = 0;
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                //console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });
        },
        async ambildata() {
            this.halamanloading = true;
            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            var random = Math.random();
            //alert(this.levelinstansi);
            if (this.roleuser == 'user') {
                this.selectedid_user = this.levelinstansi;
            }
            await mainAPI.get("parastapainnovationaduan-GetAduan?random=" + random + "&project_id=" + this.project_id + "&id_user=" + this.levelinstansi + "&role=" + this.roleuser + "&nama=" + this.carikata + "&tanggal=" + this.tanggal + "&register=" + this.register + "&lokasi=" + this.selectedlokasi + "&jenis=" + this.selectedmasteraduan + "&id_user=" + this.selectedid_user + "&saluran=" + this.selectedsaluranaduan + "&status=" + this.selectedstatus_aduan + "&idpiu=" + this.selectedid_user).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.datamaster = [];
                        this.datamaster = Response.data.content.data;
                        this.jumlahdata = Response.data.content.jumlahdata;
                        this.jumlahhalaman = Response.data.content.jumlahhalaman;
                        this.mulai = Response.data.content.mulai;
                        if (this.mulai == 0) {
                            this.halaman = 1;
                        }
                        else {
                            this.halaman = (this.mulai / 20) + 1;
                        }
                    }
                    else {
                        this.datamaster = [];
                        this.jumlahdata = 0;
                        this.jumlahhalaman = 0;
                        this.mulai = 0;
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                //console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });
        },
        prosesdata(kode) {
            var bytes = encodeURIComponent(CryptoJS.AES.encrypt(kode, 'oriproMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2').toString());
            window.location.replace("/ProsesAduanMasyarakat/" + bytes);
        },
        tindaklanjutdata(kode) {
            var bytes = encodeURIComponent(CryptoJS.AES.encrypt(kode, 'oriproMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2').toString());
            window.location.replace("/TindaklanjutAduanMasyarakat/" + bytes);
        },
        hapus(kode) {
            swal.fire({
                title: "Konfirmasi",
                text: "Yakin Hendak Hapus Data?",
                icon: "warning",
                showCancelButton: true,
                cancelButtonText: "Batal",
                confirmButtonColor: "#3a4767",
                cancelButtonColor: "#ffaa05",
                confirmButtonText: "Hapus"
            }).then((result) => {
                if (result.isConfirmed) {
                    const data = { kode: kode, project_id: this.project_id, deletedby: JSON.parse(localStorage.getItem("isistem")) }
                    const mainAPI = axios.create({
                        baseURL: process.env.VUE_APP_URL_API,
                        headers: {
                            Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                            "Content-Type": "application/x-www-form-urlencoded",
                        },
                    });
                    mainAPI.post("parastapainnovationaduan-DeleteAduanMasyarakat", data).then(
                        Response => {
                            if (Response.data.response == 'error') {
                                swal.fire('Peringatan', Response.data.message, 'error');
                            }
                            else {
                                swal.fire('Informasi', 'Data telah dihapus..', 'success').then(function () {
                                    window.location.replace("/AduanMasyarakat");
                                });
                            }
                        }
                    ).catch(
                        error => {
                            swal.fire('Peringatan', 'Terjadi Kesalahan Format Data', 'error');
                        }
                    )

                }
            });
            return false;
        },
    },
    mounted() {
        this.getOtentifikasi();
        this.ambilmaster();
        this.ambildata();
    }
}
</script>
<style></style>